
<template>
  <div class="annex-page">
    <div class="search-form">
      <el-form :model="searchData">
        <el-row>
          <el-col :span="7">
            <el-form-item label="产品类型" prop="prdType">
              <el-select
                v-model="searchData.productType"
                placeholder="请选择产品类型"
                @focus="handleSelectType"
                clearable
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="产品代码" prop="productCode">
              <el-input placeholder="请输入产品代码" v-model="searchData.productCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="产品名称" prop="productName">
              <el-input v-model="searchData.productName" placeholder="请输入产品名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="附件名称" prop="attachmentName">
              <el-input v-model="searchData.attachmentName" placeholder="请输入附件名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="附件类型">
              <el-select v-model="searchData.attachmentType" placeholder="请选择附件类型" clearable>
                <el-option
                  v-for="item in annexTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="附件状态">
              <el-select v-model="searchData.enableStatus" placeholder="请选择附件状态" clearable>
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <section class="flex-between">
      <div>
        <yh-button type="primary" size="small" @click="handleSerchClick">查询</yh-button>
        <yh-button size="small" @click="handleResetClick">清空查询条件</yh-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click="addAnnex"
          v-if="functionList.includes('327348434335666176')"
        >新增公共附件</yh-button>
      </div>
    </section>
    <el-table :data="tableData" ref="table">
      <template>{{emptyText}}</template>
      <el-table-column
        v-for="col in tableLabelList"
        :min-width="col.width"
        :label="col.label"
        :key="col.key"
        :prop="col.key"
      >
        <template slot-scope="scope">
          <span
            v-if="col.key==='attachmentType'"
          >{{scope.row.attachmentName ? attachTypeObj[scope.row.attachmentType]:''}}</span>
          <span
            v-else-if="col.key==='enableStatus'"
          >{{scope.row.enableStatus ? statusObj[scope.row.enableStatus]:''}}</span>
          <span
            v-else-if="col.key==='hasToRead'"
          >{{scope.row.hasToRead ? hasToReadObj[scope.row.hasToRead]:''}}</span>
          <span v-else>{{scope.row[col.key]?scope.row[col.key]:'—'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" min-width="180">
        <template slot-scope="scope">
          <div class="feature-container">
            <span class="button--blue" @click="previewFile(scope.row)">预览</span>
            <span
              :class="computeButtonClass(scope.row, 'attachmentType')"
              @click="updateAnnex(scope.row,validateEditForm,addAnnex,'attachmentType')"
              v-if="functionList.includes('327348982992572416')"
              :disabled="computeDisabled(scope.row,'attachmentType')"
            >修改</span>
            <span
              :class="computeButtonClass(scope.row, 'attachmentType','delete')"
              @click="deleteAttachment(scope.row,'attachmentType','delete')"
              v-if="functionList.includes('327349345980223488')"
              :disabled="computeDisabled(scope.row,'attachmentType','delete')"
            >删除</span>
            <span
              :class="computeButtonClass(scope.row, 'attachmentType')"
              @click="EDisables(scope.row,'attachmentType')"
              v-if="functionList.includes('327349247560880128')"
            >{{computeStatus(scope.row)}}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination :page.sync="currentPage" :total="sumCount" />

    <!-- 新增附件 -->
    <yh-dialog
      title="新增公共附件"
      :close-on-click-modal="false"
      :visible.sync="visibleAdd"
      :width="dialogWidth"
    >
      <el-form class="hide-error" label-width="100px" :model="addFormData" ref="addForm">
        <el-form-item label="产品类型" prop="productType" required>
          <el-select
            v-model="addFormData.productType"
            placeholder="请选择产品类型"
            @focus="handleSelectType"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件名" required prop="fileName" class="no-radius">
          <el-row>
            <el-col :span="18">
              <el-tooltip
                class="item"
                effect="dark"
                :content="addFormData.fileName"
                placement="top-end"
                :open-delay="1000"
                :disabled="addFormData.fileName.length < 15"
              >
                <el-input
                  placeholder="上传文件后，此栏自动显示"
                  :value="formatName(addFormData.fileName)"
                  style="width: 100%;"
                  class="text-ellipsis"
                  readonly
                ></el-input>
              </el-tooltip>
              <p>文件格式：pdf；文件大小：20MB以内</p>
              <p style="color:red;">{{uploadTip}}</p>
            </el-col>
            <el-col :span="6">
              <el-upload
                class="upload-demo"
                action="/wmsp/prd/file/save"
                :on-change="fileChange"
                accept=".pdf"
                :on-success="handleSuccess"
                :on-progress="handleProgress"
                :on-error="handleError"
                :before-upload="handleBeforeUpload"
                :show-file-list="false"
                :headers="{userId:userId, token:userToken}"
              >
                <el-button size="small" type="primary">{{uploadText}}</el-button>
                <div slot="tip" class="el-upload__tip">{{uploadStatus}}</div>
              </el-upload>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="文件大小(MB)" prop="annexSize">
          <el-input
            type="text"
            v-model="addFormData.annexSize"
            autofocus
            placeholder="上传文件后，此栏自动显示"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item prop="attachmentName" label="附件名称" required>
          <el-input
            type="text"
            v-model="addFormData.attachmentName"
            autofocus
            placeholder="附件名称展示到外屏给客户，如：风险提示书"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mustRead" label="是否必读" required>
          <el-radio v-model="addFormData.hasToRead" label="0">否</el-radio>
          <el-radio v-model="addFormData.hasToRead" label="1">是</el-radio>
        </el-form-item>
        <el-form-item prop="displayOrder" label="展示顺序" required>
          <el-input
            type="text"
            v-model="addFormData.displayOrder"
            autofocus
            placeholder="请输入数字，数字越大外屏展示越靠前"
          ></el-input>
        </el-form-item>
      </el-form>
      <section slot="footer">
        <el-button @click="visibleAdd=false">取消</el-button>
        <yh-button type="primary" @click="handleCheckClick"
        :disabled="buttonDisabled">提交</yh-button>
      </section>
    </yh-dialog>

    <!-- 修改附件 -->
    <yh-dialog
      title="修改公共附件"
      :close-on-click-modal="false"
      :visible.sync="visibleEdit"
      :width="dialogWidth"
    >
      <el-form class="hide-error" label-width="100px" :model="editFormData" ref="editForm">
        <el-form-item label="产品类型" prop="productType" required>
          <el-select
            v-model="editFormData.productType"
            placeholder="请选择产品类型"
            @focus="handleSelectType"
            ref="editSelect"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件名" required prop="fileName" class="no-radius">
          <el-row>
            <el-col :span="18">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editFormData.fileName"
                placement="top-end"
                :open-delay="1000"
                :disabled="editFormData.fileName.length < 15"
              >
                <el-input
                  placeholder="上传文件后，此栏自动显示"
                  :value="formatName(editFormData.fileName)"
                  style="width: 100%;"
                  class="text-ellipsis"
                  readonly
                ></el-input>
              </el-tooltip>
              <p>文件格式：pdf；文件大小：20MB以内</p>
              <p style="color:red;">{{uploadTip}}</p>
            </el-col>
            <el-col :span="6">
              <el-upload
                class="upload-demo"
                action="/wmsp/prd/file/save"
                :on-change="fileChange"
                accept=".pdf"
                :on-success="handleSuccess"
                :on-progress="handleProgress"
                :on-error="handleError"
                :before-upload="handleBeforeUpload"
                :show-file-list="false"
                :headers="{userId:userId, token:userToken}"
              >
                <el-button size="small" type="primary">{{uploadText}}</el-button>
                <div slot="tip" class="el-upload__tip">{{uploadStatus}}</div>
              </el-upload>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="文件大小(MB)" prop="annexSize">
          <el-input
            type="text"
            v-model="editFormData.annexSize"
            autofocus
            placeholder="上传文件后，此栏自动显示"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item prop="attachmentName" label="附件名称" required>
          <el-input
            type="text"
            v-model="editFormData.attachmentName"
            autofocus
            placeholder="附件名称展示到外屏给客户，如：风险提示书"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mustRead" label="是否必读" required>
          <el-radio v-model="editFormData.hasToRead" label="0">否</el-radio>
          <el-radio v-model="editFormData.hasToRead" label="1">是</el-radio>
        </el-form-item>
        <el-form-item prop="displayOrder" label="展示顺序" required>
          <el-input
            type="text"
            v-model="editFormData.displayOrder"
            autofocus
            placeholder="请输入数字，数字越大外屏展示越靠前"
          ></el-input>
        </el-form-item>
      </el-form>
      <section slot="footer">
        <el-button @click="visibleEdit=false">取消</el-button>
        <yh-button type="primary" @click="EditAnnex" :disabled="buttonDisabled">提交</yh-button>
      </section>
    </yh-dialog>
    <div id="container"></div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import { getPagingData, addNav, getFunctionList } from '@/mixins';
import annexMixins from './mixin';

const { userId, orgnInheritSign, orgnCode } = JSON.parse(
  sessionStorage.getItem('sessionData'),
);
const userToken = JSON.parse(sessionStorage.getItem('userToken'));
const baseData = {
  productType: '',
  productCode: '',
  productName: '',
  attachmentName: '',
  attachmentType: '',
  enableStatus: '',
};
export default {
  name: 'ANNEXList',
  components: {},
  mixins: [addNav, annexMixins, getPagingData, getFunctionList],
  data() {
    return {
      searchData: {
        productType: '',
        productCode: '',
        productName: '',
        attachmentName: '',
        attachmentType: '',
        enableStatus: '',
      }, // 搜索区域数据
      userToken,
      userId,
      typeOptions: [],
      emptyText: this.$LS.empty,
      tableLabelList: [
        {
          // table 中的字段
          label: '附件ID',
          key: 'id',
          width: 200,
        },
        {
          label: '产品类型',
          key: 'productType',
          width: 200,
        },
        {
          label: '附件类型',
          key: 'attachmentType',
          width: 200,
        },
        {
          label: '产品代码',
          key: 'productCode',
          width: 150,
        },
        {
          label: '产品名称',
          key: 'productName',
          width: 300,
        },
        {
          label: '附件名称',
          key: 'attachmentName',
          width: 300,
          sortable: true,
        },
        {
          label: '文件名',
          key: 'fileName',
          width: 300,
        },
        {
          label: '是否必读',
          key: 'hasToRead',
          width: 100,
          sortable: true,
        },
        {
          label: '展示顺序',
          key: 'displayOrder',
          width: 100,
        },
        {
          label: '附件状态',
          key: 'enableStatus',
          sortable: true,
          width: 100,
        },
        {
          label: '创建时间',
          key: 'createTime',
          sortable: true,
          width: 200,
        },
        {
          label: '创建人ID',
          key: 'createId',
          sortable: true,
          width: 200,
        },
        {
          label: '修改时间',
          key: 'updateTime',
          width: 300,
          sortable: true,
        },
        {
          label: '修改人ID',
          key: 'updateId',
          width: 230,
        },
      ],
      tableData: [
        {
          annexId: '0011',
          prdType: '大额存单',
          annexType: '公共附件',
          prdCode: 'BGC78952',
          prdName: '人名币日日盈',
          annexName: '客户权益须知',
          fileName: '[97]天挂钩Libor 结构性存款产品说明书1.pdf',
          mustRead: '是',
          displayOrder: 1,
          annexStatus: '启用',
          createTime: '2019-07-08 20:47:59',
          createUserId: '9990048',
          updateTime: '2019-07-08 20:47:59',
          updateUserId: '9990048',
        },
        {
          annexId: '0011',
          prdType: '大额存单',
          annexType: '公共附件',
          prdCode: 'BGC78952',
          prdName: '人名币日日盈',
          annexName: '客户权益须知',
          fileName: '[97]天挂钩Libor 结构性存款产品说明书1.pdf',
          mustRead: '是',
          displayOrder: 1,
          annexStatus: '启用',
          createTime: '2019-07-08 20:47:59',
          createUserId: '9990048',
          updateTime: '2019-07-08 20:47:59',
          updateUserId: '9990048',
        },
      ],
      visibleAdd: false,
      visibleEdit: false,
      addFormData: {
        productType: '',
        fileName: '上传文件后，此栏自动显示', // 文件名
        attachmentName: '', // 附件名
        hasToRead: '0',
        displayOrder: '',
        annex: '', // 附件
        annexSize: '',
      },
      editFormData: {
        productType: '',
        fileName: '上传文件后，此栏自动显示', // 文件名
        attachmentName: '', // 附件名
        hasToRead: '',
        displayOrder: '',
        annex: '', // 附件
        annexSize: '',
        id: '',
      },
      prdTypeOptions: [],
      rules: [
        {
          prop: 'productCode',
          required: false,
          validations: [
            {
              message: this.$MSG.M0168,
              validate: v => v.length <= 50,
            },
            {
              message: '产品代码仅能输入字母和数字',
              validate: v => /^[0-9a-zA-Z]*$/g.test(v),
            },
          ],
        },
        {
          prop: 'productName',
          required: false,
          validations: [
            {
              message: this.$MSG.M0169,
              validate: v => v.length <= 50,
            },
          ],
        },
        {
          prop: 'attachmentName',
          required: false,
          validations: [
            {
              message: this.$MSG.M0170,
              validate: v => v.length <= 50,
            },
          ],
        },
      ],
      addRules: [
        {
          prop: 'productType',
          required: true,
          message: '请选择产品类型',
        },
        {
          prop: 'annex',
          required: true,
          message: this.$MSG.M0172,
        },
        {
          prop: 'attachmentName',
          required: true,
          message: this.$MSG.M0175,
          validations: [
            {
              message: this.$MSG.M0176,
              validate: v => v.length <= 50,
            },
          ],
        },
        {
          prop: 'displayOrder',
          required: true,
          message: '请输入展示顺序',
          validations: [
            {
              message: '展示顺序仅支持0-999999范围内的整数',
              validate: v => v <= 999999,
            },
            {
              message: '展示顺序仅支持0-999999范围内的整数',
              validate: v => /^[0-9]*$/.test(v),
            },
          ],
        },
      ],
      editRules: [
        {
          prop: 'productType',
          required: true,
          message: '请选择产品类型',
        },
        {
          prop: 'attachmentName',
          required: true,
          message: this.$MSG.M0175,
          validations: [
            {
              message: this.$MSG.M0176,
              validate: v => v.length <= 50,
            },
          ],
        },
        {
          prop: 'displayOrder',
          required: true,
          message: '请输入展示顺序',
          validations: [
            {
              message: '展示顺序仅支持0-999999范围内的整数',
              validate: v => v <= 999999,
            },
          ],
        },
      ],
      dialogWidth: '570px',
      annexTypeOptions: [
        {
          label: '公共附件',
          value: 'common',
        },
        {
          label: '个性化附件',
          value: 'customerized',
        },
      ],
      statusOptions: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 0,
        },
      ],
      sumCount: 0,
      currentPage: 1,
      searchParam: {
        ...baseData,
        userId,
        orgnInheritSign,
        orgnCode,
      },
      fileList3: [],
      functionList: [],
      uploadFileObj: {},
      uploadText: '点击上传',
      uploadStatus: '',
      uploadTip: '',
      editing: false, // 判断是否是编辑
      attachTypeObj: { common: '公共附件', customerized: '个性化附件' },
      hasToReadObj: {
        0: '否',
        1: '是',
      },
      statusObj: {
        0: '禁用',
        1: '启用',
      },
      buttonDisabled: false,
      canupload: true,
      unsuccessEditObj: '', // 修改不成功的时候保存当前行的数据
    };
  },
  watch: {
    currentPage: {
      immediate: false,
      handler() {
        this.listAnnex();
      },
    },
  },
  mounted() {
    this.listAnnex();
    console.log('测试token', this.userToken);
  },
  methods: {
    formatName(name) {
      if (name.length >= 15) {
        return `${name.slice(0, 10)}...`;
      }
      return name;
    },
    listAnnex() {
      this.getPagingData(this.$API.annexList);
    },
    handleSerchClick() {
      if (this.validateSearchForm()) {
        this.postSearchData();
      }
    },
    validateSearchForm() {
      return this.validate(this.rules, this.searchData);
    },
    validateAddForm() {
      return this.validate(this.addRules, this.addFormData);
    },
    validateEditForm() {
      return this.validate(this.editRules, this.editFormData);
    },
    // 查找附件请求
    postSearchData() {
      this.searchParam = {
        ...this.searchParam,
        ...this.searchData,
      };
      this.listAnnex();
    },
    handleResetClick() {
      // 清空筛选条件
      // eslint-disable-next-line no-return-assign
      Object.keys(this.searchData).forEach(key => (this.searchData[key] = ''));
    },
    addAnnex() {
      this.buttonDisabled = false;
      this.visibleAdd = true;
      this.uploadStatus = '';
      this.uploadText = '点击上传';
      this.uploadTip = '';
      // eslint-disable-next-line no-return-assign
      Object.keys(this.addFormData).forEach(
        // eslint-disable-next-line no-return-assign
        key => (this.addFormData[key] = ''),
      );
      this.$set(this.addFormData, 'displayOrder', '');
      this.$set(this.addFormData, 'fileName', '上传文件后，此栏自动显示');
      this.addFormData.hasToRead = '0';
    },
    // 新增附件
    handleCheckClick() {
      if (this.validateAddForm()) {
        // 新增，判断是否上传了文件
        if (this.canupload) {
          this.postAddAnnex();
        } else {
          this.$message.error('请上传文件，等待文件上传成功');
        }
      }
    },
    postAddAnnex() {
      this.buttonDisabled = true;
      // eslint-disable-next-line no-unused-vars
      const { fileUrl, id } = this.uploadFileObj;
      const parames = {
        data: {
          ...this.addFormData,
          fileSize: this.addFormData.annexSize,
          fileUrl,
          fileId: id,
        },
      };
      // 先上传文件，再上传附件
      this.$_post(this.$API.uploadAttachment, parames)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            // 上传附件
            this.$message.success(`${this.$MSG.M0178}`);
            this.visibleAdd = false;
            //  this.buttonDisabled = false;
            this.listAnnex();
          } else {
            this.$message.success(`${this.$MSG.M0030}`);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 文件状态改变时的钩子
    fileChange(file) {
      console.log('change');
      console.log(file);
      if (this.visibleEdit) {
        this.editFormData.annex = file.raw;
        this.editFormData.fileName = file.name;
        this.editFormData.annexSize = (file.size / 1024 / 1024).toFixed(1);
      } else {
        this.addFormData.annex = file.raw;
        this.addFormData.fileName = file.name;
        this.addFormData.annexSize = (file.size / 1024 / 1024).toFixed(1);
      }
      console.log(this.addFormData.annex);
    },
    // 预览附件
    previewFile(row) {
      // 打开一个新的tab
      this.addNav({
        path: '/annex-preview',
        query: {
          ...row,
        },
        name: '附件预览',
      });
    },
    handleChange(file, fileList) {
      this.fileList3 = fileList.slice(-3);
    },
    handleSuccess(response) {
      this.uploadStatus = '上传成功';
      // 如果是新增是否可以上传附件
      this.canupload = true;
      this.uploadFileObj = {
        ...response.data.info,
      };
    },
    handleProgress() {
      this.uploadText = '重新上传';
      this.uploadStatus = '上传中';
    },
    handleError() {
      this.uploadStatus = '上传失败';
    },
    handleBeforeUpload(file) {
      this.uploadTip = '';
      this.canupload = false;
      this.uploadStatus = '';
      // 上传前判断文件大小
      // return new Promise((resolve, reject) => {
      //   const extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      //   const size = file.size / 1024 / 1024;
      //   debugger
      //   if (extension !== 'pdf') {
      //     this.uploadTip = '上传文件格式不正确,仅支持pdf!';
      //     reject();
      //   } else if (size > 20) {
      //     this.uploadTip = '上传文件大小不能超过20M!';
      //     reject();
      //   } else {
      //     resolve();
      //   }
      // });
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      const size = file.size / 1024 / 1024;
      if (extension !== 'pdf') {
        this.uploadTip = '上传文件格式不正确,仅支持pdf!';
        return false;
      }
      if (size > 20) {
        this.uploadTip = '上传文件大小不能超过20M!';
        return false;
      }
      return true;
    },
    // eslint-disable-next-line space-before-blocks
    computeButtonClass(row, key, flag = '') {
      if (flag === 'delete' && row[key] !== 'customerized') {
        return 'button--red';
      }
      if (row[key] === 'common') {
        return 'button--blue';
      }
      if (row[key] === 'customerized' || row.enableStatus === '1') {
        return 'button--grey';
      }
      return 'button--blue';
    },
    computeDisabled(row, key, flag = '') {
      // let t= this.computeButtonClass(row, key, flag);
      // debugger
      if (this.computeButtonClass(row, key, flag) === 'button--grey') {
        return true;
      }
      return false;
    },
    computed: {
      // ！！！在computed里面可以设置头部信息，如增加tooken
      headers() {
        return {
          userId,
          token: userToken,
        };
      },
    },
  },
};
</script>

<style scoped lang="scss">
.annex-page {
  .yh-dialog .el-form {
    width: 525px;
    .el-upload__tip {
      color: red;
    }
  }
}
.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
<style lang="scss">
.annex-page {
  .no-radius {
    label {
      transform: translate(0, 2px);
    }
    .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      height: 32px;
    }
    .el-button--small {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
